import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, NavItem, Table } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import { authKey, GET_DELIVERY_CHALLAN_DETAILS, PRINT_DOWNLOAD_DATA } from '../../../common/URLs';

import { useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { loaderService } from "../../../common/custom-loader/loader-service";
import { PROD } from "../../../common/constants";
import { getLocalStorageItem } from '../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import { Fab, Typography, Button, Grid, Stack, Divider, CardContent, Card, Container, Box } from '@mui/material';
import moment from 'moment';
import { DataGrid } from '@mui/x-data-grid';
import { QuickSearchToolbar } from '../../../payment/common/commonFunctions';
import { v4 as uuidv4 } from 'uuid';
import { useTranslation } from 'react-i18next';
import apiClient from '../../../axios';

export function DeliveryChalanDetails(props) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();
  const challanDetails = state?.selectedRow;
  const [getDeliveryChallanDetails, setGetDeliveryChallanDetails] = useState();
  const [downloadDeliveryChallan, setDownloadDeliveryChallan] = useState();

  useEffect(() => {
    getChallanDetails();
  }, []);

  const getChallanDetails = () => {
    loaderService.showLoader()
    apiClient
      .post(
        GET_DELIVERY_CHALLAN_DETAILS,
        {
          "challanNo": challanDetails?.challanNo,
        },
        {
          headers: {
            Authorization: "Bearer " + getLocalStorageItem('id_token'),
          },
        },
        null
      )
      .then((response) => {
        setGetDeliveryChallanDetails(response.data.challanDetails);
        loaderService.hideLoader()
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader()
        toast.error(error.message);
      });
  };

  const getDownloadChallan = (action) => {
    // console.log("Print");
    loaderService.showLoader();
    apiClient
      .post(PRINT_DOWNLOAD_DATA,
        {
          "printDataByNumber": getDeliveryChallanDetails?.challanNo,
          "printDetailsType": props?.onlyRb ? "RB_Challan" : "delivery_challan",
        },
        {
          responseType: 'blob',
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

            Accept: 'application/pdf'
          }
        }, null
      )
      .then((response) => {
        setDownloadDeliveryChallan(response.data);
        const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

        if (action === "download") {
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Output.pdf`
          );
          document.body.appendChild(link);

          link.click();
          link.parentNode.removeChild(link);
        }
        if (action === "print") {
          let iframe = document.createElement('iframe');
          document.body.appendChild(iframe);
          iframe.style.display = 'none';
          iframe.src = url;
          iframe.onload = function () {
            setTimeout(function () {
              iframe.focus();
              iframe.contentWindow.print();
            }, 1);
          };
        }
        loaderService.hideLoader();
      }).catch(function (error) {
        console.log(error);
        loaderService.hideLoader();
        toast.error(error.message);
      });
  }

  const orderColumns = [
    { field: 'poNo', headerName: "Order Number", flex: 1 },
    {
      field: 'poDate', headerName: "Order Date", flex: 1,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
  ]

  const shippingColumns = [
    {
      field: 'shippingDate', headerName: "Shipping Date", width: 120,
      valueFormatter: params => moment(params?.value).format("DD/MM/YYYY")
    },
    { field: 'shippedByName', headerName: "Shipped By (Name)", width: 180 },
    { field: 'shippedByPhone', headerName: "Shipped By (Phone)", width: 150 },
    { field: 'vehicleRegNo', headerName: "Shipped By (Vehicle)", width: 150 },
    { field: 'driverName', headerName: "Driver Name", width: 180 },
    { field: 'driverPhone', headerName: "Drive Phone Number", width: 150 },
  ]

  const columns = [
    // { field: 'scheduleLineNumber', headerName: t('pit.lineNo'), width: 100 },
    { field: 'itemCode', headerName: t('pit.itemCode'), flex: 1 },
    {
      field: 'materialType', headerName: t('pit.ItemDescHSNCode'), flex: 1,
    },
    { field: 'expectedQuantity', headerName: t('pit.ExpectedQuantity'), flex: 1 },
    { field: 'quantity', headerName: t('pit.ActualQuantity'), flex: 1 },
    // {
    //   field: 'uom', headerName: t('pit.uom'), flex: 1,
    //   valueFormatter: () => "MT"
    // }
  ];

  // const inVoiceTemplate = () =>

  return (
    <>
      {/* <Container maxWidth="xxl">
        <Row>
          <Col xs={12} md={12} >
            <div id="noprint"> {inVoiceTemplate()}</div>
          </Col>
        </Row>
      </Container>
      <div id="print"> {inVoiceTemplate()}</div> */}
      <Container maxWidth="xxl">
        {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT37</p>}
        <Typography variant="h4" sx={{ mb: 2 }}>
          <Fab onClick={() => { navigate('../deliveryChalanList', { state: { tabValue: state?.tabValue } }) }} size="small" aria-label="back" title='Back'>
            <KeyboardArrowLeftRounded />
          </Fab> Delivery Challan 
        </Typography>
        <Card>
          <CardContent>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} mt={2} divider={<Divider orientation="vertical" flexItem />}>
              <Stack direction="column">
                {/* <Typography variant="subtitle1" gutterBottom>{t('pit.invoiceDetails')}</Typography> */}
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Delivery Chalan No: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", whiteSpace: "nowrap" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Delivery Chalan Date : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {moment(getDeliveryChallanDetails?.challanDate).format("DD/MM/YYYY")}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Supplier Name : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.vendorName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Consignment No. : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", whiteSpace: "nowrap" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.consignmentNo}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="column">
                <Typography variant="subtitle1" gutterBottom>Pick-Up Details</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Name : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.sourceName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.sourceUrn}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Contact Person : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", whiteSpace: "nowrap" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.sourceContactPerson}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Phone Number : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.sourceContactNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Address: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", wordBreak: 'break-all' }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.sourceAddress}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GSTIN: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails?.[0]?.sourceGSTIN}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Place of Supply: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails?.[0]?.sourceLocation}
                  </Typography>
                </Stack>
              </Stack>
              <Stack direction="column">
                <Typography variant="subtitle1" gutterBottom>Delivery Details</Typography>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Name: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.destinationName}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>URN : </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.destinationUrn}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Contact Person: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", whiteSpace: "nowrap" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.destinationContactPerson}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" sx={{ display: "inline", whiteSpace: "nowrap" }} gutterBottom>Phone Number: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.destinationContactNo}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Address: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw", wordBreak: 'break-all' }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails[0]?.destinationAddress}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>GSTIN: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails?.[0]?.destinationGSTIN}
                  </Typography>
                </Stack>
                <Stack direction="row">
                  <Typography variant="subtitle2" gutterBottom>Place of Delivery: </Typography>
                  <Typography style={{ display: "inline", marginLeft: "1vw" }} variant="body2" gutterBottom>
                    {getDeliveryChallanDetails?.challanSourceDestinationDetails?.[0]?.destinationLocation}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Grid container spacing={1} direction={{ xs: 'column', sm: 'row' }}>
              <Grid item xs={12} md={5} direction="column">
                <Typography sx={{ marginTop: "4vh" }} variant="subtitle1" gutterBottom>{t('pit.orderDetails')}</Typography>
                <DataGrid
                  autoHeight
                  rows={getDeliveryChallanDetails?.challanSourceDestinationDetails ? getDeliveryChallanDetails?.challanSourceDestinationDetails.map((item) => ({ ...item, id: uuidv4(), poNo: getDeliveryChallanDetails?.poNumber })) : []}
                  columns={orderColumns}
                  hideFooterPagination
                />
              </Grid>
              <Grid item xs={12} direction="column">
                <Typography style={{ marginTop: "4vh" }} variant="subtitle1" gutterBottom>{t('pit.shippingDetails')}</Typography>
                <DataGrid
                  autoHeight
                  rows={getDeliveryChallanDetails?.challanSourceDestinationDetails ? getDeliveryChallanDetails?.challanSourceDestinationDetails.map((item) => ({ ...item, id: uuidv4(), vehicleRegNo: getDeliveryChallanDetails?.vehicleRegNo })) : []}
                  columns={shippingColumns}
                  hideFooterPagination
                />
              </Grid>
            </Grid>
            <DataGrid style={{ marginTop: "4vh" }}
              autoHeight
              rows={getDeliveryChallanDetails?.challanSourceDestinationDetails ? getDeliveryChallanDetails?.challanSourceDestinationDetails.map((item) => ({ ...item, id: uuidv4() })) : []}
              columns={columns}
              hideFooterPagination
            />
          </CardContent>
        </Card>
        <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          <Button variant="contained" onClick={() => getDownloadChallan("download")}>{t('pit.download')}</Button>
          <Button variant="contained" sx={{ ml: 2 }} onClick={() => getDownloadChallan("print")}>{t('pit.print')}</Button>
        </Box>
      </Container>
    </>
  )
}
export default DeliveryChalanDetails;